import { API_STATUS } from '../../../utilities/constants';
import manageReservationTypes from './manageReservation.types';

const INITIAL_STATE = {
  data: {},
  manageReservationApiStatus: API_STATUS.IDLE,
  errorMessage: null,
  packagesUpdated: null,
  cabanaApiStatus: API_STATUS.IDLE,
  cabanaErrorMessage: null
};

const manageReservationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.SUCCEEDED,
        data: { ...state.data, ...action.response },
        errorMessage: null,
        packagesUpdated: action?.packagesUpdated ?? null
      };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_FAILURE:
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_FAILURE:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, data: {}, errorMessage: action.message };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, ...action.response },
        addGuestsReservationObj: action.response,
        errorMessage: null
      };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, errorMessage: action.message };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR:
      delete state.addGuestsReservationObj;
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, errorMessage: null };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR:
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, errorMessage: null };

    case manageReservationTypes.GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, ...action.response },
        errorMessage: null
      };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        upsellAddOns: action.response,
        errorMessage: null
      };

    case manageReservationTypes.CLEAR_MANAGERESERVATIONDETAILS:
      return { ...state, ...INITIAL_STATE };
    case manageReservationTypes.GET_COMPARISON_CHANGES_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.GET_COMPARISON_CHANGES_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, comparisonChanges: action.response },
        errorMessage: null
      };
    case manageReservationTypes.GET_COMPARISON_CHANGES_FAILURE:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, data: {}, errorMessage: action.message };
    case manageReservationTypes.GET_COMPARISON_CHANGES_CLEAN:
      delete state.data.comparisonChanges;
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, data: { ...state.data }, errorMessage: null };
    case manageReservationTypes.CLEAR_RESERVATION_PACKAGES_UPDATE:
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, packagesUpdated: null, errorMessage: null };
    case manageReservationTypes.FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS:
      return { ...state, dynamicTile: action.response };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_DETAILS_ERROR:
      return { ...state, errorMessage: null };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_IS_LOADING:
      return { ...state, cabanaApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_SUCCESS:
      return { ...state, cabanaApiStatus: API_STATUS.SUCCEEDED };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_FAILURE:
      return { ...state, cabanaApiStatus: API_STATUS.ERROR, cabanaErrorMessage: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_CABANA_DETAILS:
      return { ...state, cabanaApiStatus: API_STATUS.IDLE, cabanaErrorMessage: null };
    case manageReservationTypes.PACKAGE_RESERVATION_LOADING_ERROR:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, packageErrorMessageData: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR:
      return { ...state, packageErrorMessageData: null };
    case manageReservationTypes.CHANGE_RESERVATION_TYPE:
      return {
        ...state,
        reservationId: action.reservationId,
        data: {
          ...state.data,
          id: action.reservationId,
          reservationType: action.reservationType,
          arrival: action.startDate,
          departure: action.endDate
        }
      };
    case manageReservationTypes.FETCH_RESERVATION_PERSONALIZE_ADDON:
      return { ...state, recommendedAddOns: action.response };
    case manageReservationTypes.CLEAR_CONFIRMATION_RECOMMENDATION:
      return { ...state, recommendedAddOns: null };
    default:
      return state;
  }
};

export default manageReservationReducer;
